module.exports = __webpack_public_path__ + "img/result-btn_txt.0b114419.png";